import React from 'react'
import Text, { TextGold, TextGoldRepeat } from '../styledComponents/TextStyled'
import { CardWinnerContainer,ContainerText } from './CardWinner'
import { HiOutlineSlotMachine } from './Icons'
import { numberFormat } from '../util'

const CardWinnerProgressive = (props) => {
  return (
    <CardWinnerContainer>
      {props.machine &&
      <>
        <TextGold textStyle='xlarge' style={{fontSize:"11vh"}}>{props.name}</TextGold>
        <ContainerText>
          <Text textStyle='xlarge' style={{fontSize:"9vh"}}>{props.currencySymbol} {numberFormat(props.amount)}</Text>
        </ContainerText>
        <ContainerText $flexDirection='row'>
          <Text textStyle='large' >Máquina {props.machine}</Text>
          <HiOutlineSlotMachine size={42}/>
        </ContainerText>
        <ContainerText>
          <Text>ES LA POSICIÓN</Text>
          <TextGoldRepeat textStyle='xlarge'>¡GANADORA!</TextGoldRepeat>
        </ContainerText>
        {props.winnerDocument &&
          <ContainerText>
            <Text textStyle='xlarge'>{'CLIENTE: ' + props.winnerName}</Text>
            <Text textStyle='xlarge'>{(props.winnerDocumentTypeName || 'documento') + ': ' + props.winnerDocument}</Text>
          </ContainerText>
        }
      </>
      }
    </CardWinnerContainer>
  )
}

export default CardWinnerProgressive
